import parseHTML from "../lib/dom/funciones/parse_html";
import swipe from "../lib/swipe";

const impacto = () => {
    Array.from(document.querySelectorAll<HTMLElement>('.impacto__contenido')).forEach(contenedor => {
        const lista = contenedor.querySelector<HTMLElement>('.impacto__datos');

        if (!lista) {
            return;
        }

        let actual = 0;

        const cambiar = (i: number) => () => {
            actual = i;
            lista.style.setProperty('--posicion', i.toString());
            botones.forEach((boton, index) => {
                boton.setAttribute('aria-checked', index === i ? 'true' : 'false');
                boton.setAttribute('tabindex', index === i ? '0' : '-1');
            });
        }

        const datos = Array.from(lista.querySelectorAll<HTMLElement>('.impacto__dato'));
        const bolitas = parseHTML('<div class="impacto__bolitas" role="radiogroup" aria-label="Opciones disponibles"></div>');
        const botones = datos.map((dato, index) => {
            const bolita = parseHTML(`<button type="button" role="radio" aria-checked="${index === 0 ? 'true' : 'false'}" tabindex="${index == 0 ? 0 : -1}" class="impacto__bolita" aria-label="Impacto ${index + 1}">${index + 1}</button>`);
            bolita.setAttribute('data-index', index.toString());
            bolita.setAttribute('aria-label', 'Ver dato ' + (index + 1));
            bolita.addEventListener('click', cambiar(index));
            bolitas.appendChild(bolita);

            return bolita;
        });

        swipe(lista,
            () => cambiar(actual === datos.length - 1 ? 0 : actual + 1)(),
            () => cambiar(actual === 0 ? datos.length - 1 : actual - 1)()
        );

        bolitas.addEventListener('keydown', (e) => {
            const target = e.target as HTMLElement;

            if (target.classList.contains('impacto__bolita')) {
                let nuevoIndex = actual;

                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                    nuevoIndex = actual === datos.length - 1 ? 0 : actual + 1;
                    e.preventDefault();
                } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                    nuevoIndex = actual === 0 ? datos.length - 1 : actual - 1;
                    e.preventDefault();
                }

                if (nuevoIndex !== actual) {
                    cambiar(nuevoIndex)();
                    botones[nuevoIndex].focus();
                }
            }
        });

        contenedor.appendChild(bolitas);
    });
}

export default impacto;